var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`my-4 v-label theme--${_vm.theme}`},[_vm._v("Primary")]),_c('v-color-picker',{attrs:{"dot-size":"25","swatches-max-height":"200","elevation":"5","hide-inputs":""},model:{value:(_vm.primaryColour),callback:function ($$v) {_vm.primaryColour=$$v},expression:"primaryColour"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }